//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Survey = (function () {
    var mySurvey = {
        Index: function () {
            $('[data-role="toggle-survey-dates"]').on('click',
                function () {
                    if ($(this).val() == "True") {
                        $('[data-role="survey-date"]').hide();
                        $('[data-role="survey-date"]').find('input[type="text"]').val("");
                    } else {
                        $('[data-role="survey-date"]').show();
                    }
                });

            $('[data-role="save-survey"]').on('click',
                function () {
                    if ($('input[name="AddSurvey.Name"]').val() == '') {
                        toastr.info("Please add a name.", "Data Validation Warning");
                        return;
                    }

                    $.ajax({
                        url: $(this).data('url'),
                        type: 'POST',
                        data: $('#frmAddSurvey').serialize(),
                        async: false,
                        success: function (result) {
                            if (result == "Success") {
                                toastr.success("Survey saved successfully.", "Save Successful");
                                $('#frmAddSurvey').trigger("reset");
                                $('#pnlAddSurvey').hide();
                                app.KendoGrids.GetResults('gridSurvey');
                            } else {
                                //Was an error
                                toastr.error("There was an error saving your survey.", "Error!");
                            }
                        },
                        error: function (result) {
                            toastr.error("There was an error saving your survey.", "Error!");
                        }
                    });
                });


            $("#gridSurvey").kendoGrid({
                columns: [{
                    field: "Id",
                    hidden: true
                },
                {
                    field: "Name",
                    title: "Title",
                    width: "300px"
                },
                {
                    field: "SurveyStart",
                    title: "Start",
                    format: "{0:M/d/yyyy}",
                    width: "75px"

                },
                {
                    field: "SurveyEnd",
                    title: "End",
                    format: "{0:M/d/yyyy}",
                    width: "75px"

                },
                {
                    field: "Status",
                    title: "Status",
                    width: "75px"
                },
                {
                    field: "SurveyedCount",
                    title: "Surveyed Users",
                    width: "75px"
                },
                {
                    template: "<a target='_blank' class='uw-button tiny info remove-rounded-corners' href='/Survey/Details/#=Id#'>Details</a>"
                }],
                data: {
                    schema: {
                        model: {
                            fields: {
                                SurveyStart: { type: "date" },
                                SurveyEnd: { type: "date" }
                            }
                        }
                    }
                },
                scrollable: false,
                sortable: true,
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridSurvey", true);
        },
        Init: function () {
            $(document).on("click", "[data-role='toggle-survey-dates']", function () {
                if ($(this).val() == "True") {
                    $('[data-role="dates"]').hide();
                    $('[data-role="dates"]').find('input[type="text"]').val("");
                } else {
                    $('[data-role="dates"]').show();
                }
            });
            mySurvey.AdjustCriteriaHeights();
            $(document).on("component-bind-edit-mode-complete-SurveyDetails", function (e, component) {
                mySurvey.InitDurationRadioButtons();
            });

            $("div[id='divSurveyCommitteePartialView']").on('click', ".fa-chevron-down", function () {
                $(this).closest(".row").next(".row").slideDown(500);
                $(this).removeClass("fa-chevron-down");
                $(this).addClass("fa-chevron-up");
            });

            $("div[id='divSurveyCommitteePartialView']").on('click', ".fa-chevron-up", function () {
                $(this).closest(".row").next(".row").slideUp(500);
                $(this).removeClass("fa-chevron-up");
                $(this).addClass("fa-chevron-down");
            });

            $("#ddlPossibleCommittees").on('click', function () {
                $("#ddlPossibleCommittees").css('outline-color', '');
            });

            $(document).on("click", 'button[name="btnRemove"]', function () {
                if (confirm("Are you sure you want to remove '" + $(this).closest('.committee').find('h5:first-child').text() + "' from this survey?")) {
                    $.ajax({
                        url: '/Survey/DeleteCommitteeSurvey',
                        type: 'POST',
                        data: JSON.stringify({
                            'CommitteeSurveyId': $(this).attr("value"),
                            'SurveyId': $('#hdnSurveyId').val(),
                        }),
                        async: false,
                        contentType: 'application/json; charset=utf-8',
                        success: function (partialViewResult) {
                            $("#divCommitteesPartial").html(partialViewResult);
                        },
                        error: function (result) {
                            toastr.error("There was an error removing the committee.", "Error!")
                        }
                    });
                }
            });
        },
        InitDurationRadioButtons: function () {
            if ($("input[name='IsOngoing']:checked").val() == "True") {
                $('[data-role="dates"]').hide();
                $('[data-role="dates"]').find('input[type="text"]').val("");
            } else {
                $('[data-role="dates"]').show();
            }
        },
        AddCommitteeToSurvey: function AddCommitteeToSurvey(url) {
            if ($("#ddlPossibleCommittees").val() != "") {
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: JSON.stringify({
                        'CommitteeId': $("#ddlPossibleCommittees").val(),
                        'SurveyId': $("#hdnSurveyId").val()
                    }),
                    async: false,
                    contentType: 'application/json; charset=utf-8',
                    success: function (partialViewResult) {
                        $("#divCommitteesPartial").html(partialViewResult);
                    },
                    error: function (result) {
                        toastr.error("There was an error adding the committee.", "Error!")
                    }
                });
            }
            else {
                $("#ddlPossibleCommittees").focus();
                $("#ddlPossibleCommittees").css('outline-color', '#FF0000');
            }
        },
        AdjustCriteriaHeights: function AdjustCriteriaHeights() {
            var leftCriteria = $(".eligible-partial .criteria");
            var rightCriteria = $(".ineligible-partial .criteria");

            if (leftCriteria.length == rightCriteria.length) {
                for (var index = 0; index < leftCriteria.length; index++) {
                    $(leftCriteria[index]).height("auto");
                    $(rightCriteria[index]).height("auto");

                    var height = Math.max($(leftCriteria[index]).css("height").replace(/[^-\d\.]/g, ''), $(rightCriteria[index]).css("height").replace(/[^-\d\.]/g, ''));
                    $(leftCriteria[index]).height(height);
                    $(rightCriteria[index]).height(height);
                }
            }
        }
    };
    return mySurvey;
}());